// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1FKjg","label":"Radio_label__3Auei","checkMark":"Radio_checkMark__1xFXC","disabled":"Radio_disabled__3edTH"};